import { ThemeUICSSObject } from 'theme-ui';

export const assistant: ThemeUICSSObject = {
  floatingAssistant: {
    '& div.modal__content[class]': {
      flex: '1 1 auto',
      flexBasis: 'auto',
      minHeight: 0,
      overflow: 'hidden',
      p: 3,
      width: 'min(90vw, 500px)',
    },

    '.modal__main': {
      height: '95vh',
      maxHeight: '95vh',
      minHeight: '50vh',
      maxWidth: 'unset',
      overflow: 'hidden',
    },

    '.chat_controller': {
      height: '100%',
      maxHeight: '100%',
      minHeight: 0,
    },

    '.chatHistoryVirtualScroller.assistantHistory': {
      flex: '1 1 auto',
      height: '100% !important',
      minHeight: 0,
      overflow: 'auto',
    },

    '#floatingAssistant': {
      minWidth: '500px',
    },
  },
};
